var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172.9 75.3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "KIO",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M60.04 69.7H43.78C40.57 56.88 29.47 47.2 15.93 46.1V69.7H0V1.26H15.93V30.15C15.93 30.15 15.94 30.15 15.94 30.16C38.3 31.34 56.53 48.05 60.04 69.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M59.9 1.26C59.88 5.58 59.86 10.7 59.83 27.37C59.12 15.2 53.45 26.2 44.99 34.13C40.31 30.69 35.07 28.77 29.42 26.13C37.59 20.95 43.25 12.09 43.92 1.71L59.9 1.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M87.75 23.69H71.81V69.7H87.75V23.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M87.75 1.46H71.81V17.89H87.75V1.46Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M136.53 71.4C157.33 71.4 172.86 56.07 172.86 35.65C172.86 15.23 157.33 0 136.53 0C115.62 0 100.01 15.43 100.01 35.65C100.01 55.87 115.62 71.4 136.53 71.4ZM136.53 57.43C124.32 57.43 115.04 48.56 115.04 35.65C115.04 22.74 124.32 13.85 136.53 13.85C148.74 13.85 157.98 22.75 157.98 35.65C157.98 48.56 148.74 57.43 136.53 57.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioLogo);
export default __webpack_public_path__ + "static/media/kio-logo.3a3ae812dc0956599dbb5dcfc5166f50.svg";
export { ForwardRef as ReactComponent };